import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Label from 'ui-library/bs/Label';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

function renderChip(id: string, isLink?: boolean): JSX.Element {
  return <BenchChip key={id} id={id} size={ChipSize.SMALL} className={css(styles.chip)} isLink={isLink} />;
}

interface Props {
  ids: Array<string>;
  maxChips: number;
  title: string;
  chipsAreLinks?: boolean;
}

/**
 * Shows a labeled horizontal list of chips.
 *
 * Similar to `ChipList` except this renders chips horizontally rather than vertically and does not have a way
 * to render overflow chips when the number of items exceeds maxChips.
 */
export default function HorizontalChipListField(props: Props): JSX.Element {
  return (
    <div>
      <Label>{props.title}</Label>
      <div className="chipWrapper">
        {props.ids.length > props.maxChips
          ? props.ids.slice(0, props.maxChips).map((id) => renderChip(id, props.chipsAreLinks))
          : props.ids.map((id) => renderChip(id, props.chipsAreLinks))}
        <div>
          {props.ids.length > props.maxChips ? `...and ${props.ids.length - props.maxChips} more` : null}
        </div>
      </div>
    </div>
  );
}

HorizontalChipListField.defaultProps = {
  maxChips: 50,
};

const styles = StyleSheet.create({
  chip: {
    marginBottom: '10px',
  },
});
